import React from 'react'
import TFA from '../TFA/index.jsx'

const FormatDataSelect = props => {
    const translation = JSON.parse(localStorage.translation)[localStorage.language]
    let {
        item,
        profileDataParams,
        tfaType,
        dataProtection,
        getStatus,
        profileDataChange
    } = props

    if (item.key === '2fa_available_types') {
        item['options'] = item['options'].filter(option => {
            if (option !== item['value']) {
                return option
            }
        })
        return (
            <TFA
                currentData={item}
                tfaType={tfaType}
                dataProtection={dataProtection}
                getStatus={getStatus}
            />
        )
    } else {
        let optionList = item.options.map((prop, i) => {
            return <option key={i}>{translation[prop]}</option>
        })

        return (
            <select
                value={profileDataParams[item.key]}
                onChange={event => profileDataChange(item, event)}
            >
                {optionList}
            </select>
        )
    }
}

export default FormatDataSelect
